import {Injectable, NgZone} from "@angular/core";
import {default as OneSignalPlugin} from "onesignal-cordova-plugin";

@Injectable()
export class Location {
  constructor(private readonly ngZone: NgZone) {
  }

  /**
   * Prompts the user for location permissions to allow geotagging from the OneSignal dashboard.
   */
  requestPermission(): void {
    OneSignalPlugin.Location.requestPermission();
  };

  /**
   * Disable or enable location collection (defaults to enabled if your app has location permission).
   */
  setShared(shared: boolean): void {
    OneSignalPlugin.Location.setShared(shared);
  };

  /**
   * Whether location is currently shared with OneSignal.
   */
  isShared(): Promise<boolean> {
    return this.ngZone.runOutsideAngular(() => new Promise<boolean>((resolve, reject) => {
      OneSignalPlugin.Location.isShared()
        .then(
          (result) => {
            this.ngZone.run(() => {
              resolve(result);
            });
          },
          (reason) => {
            this.ngZone.run(() => {
              reject(reason);
            });
          },
        );
    }));
  };
}
